export default "__VITE_ASSET__DkbEvFLH__"